module.exports = __webpack_public_path__ + "static/media/Mercedez-Benz@2x.d6bb27b4.png";